// extracted by mini-css-extract-plugin
export default {"banner_img":"terms-and-conditions_banner_img__SykHw","hr":"terms-and-conditions_hr__m5qJC"};